module.exports = __webpack_public_path__ + "static/media/Bitmap.0df774b7.svg";